import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33316d77"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "auth-form__title" }, "Вход в приложение \"Пионер\"", -1))
const _hoisted_3 = { class: "auth-form__subtitle" }
const _hoisted_4 = {
  key: 0,
  class: "auth-form__subtitle"
}
const _hoisted_5 = {
  key: 1,
  class: "auth-form__error"
}

import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { initBridge } from "@/api/interceptors";
import { useMaxValidation } from "@/use/useMaxValidation";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthFormMax',
  setup(__props) {

const { loginMaxData } = useMaxValidation();
const router = useRouter();
const route = useRoute();
const userData = ref<any>(null);

const errorMessage = computed(() => {
  return (
    error.value?.response?.data?.error?.message ||
    error.value?.response?.data?.message ||
    error.value?.message ||
    String(error.value)
  );
});

const subtitle = computed(() => {
  return max_data.value
    ? "Пожалуйста, ожидайте"
    : "Данный способ авторизации работает только через мессенджер МАКС";
});

const max_data = ref<any>(null);
const user = ref<any>(null);
const loading = ref<any>(false);
const error = ref<any>(null);
const response_2 = ref<any>(null);

async function checkMaxData() {
  try {
    max_data.value = await initBridge();
  } catch (e) {
    error.value = e;
    return;
  }

  if (max_data.value?.initData) {
    const { score_id } = route.query;

    try {
      error.value = null;
      loading.value = true;

      response_2.value = await loginMaxData(
        max_data.value.initData,
        Number(score_id),
      );

      router.push("/");
    } catch (e: any) {
      error.value = e;
      user.value = null;
    } finally {
      loading.value = false;
    }
  }
}

onMounted(async () => {
  await checkMaxData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(subtitle)), 1),
    (loading.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Загрузка..."))
      : _createCommentVNode("", true),
    (error.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, "❌ " + _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})